var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-3",attrs:{"id":"map"}},[_c('GmapMap',{staticStyle:{"width":"500px","height":"450px"},attrs:{"center":{lat:42.881363, lng:-85.617624},"zoom":11,"map-type-id":"roadmap","options":{
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: true,
      disableDefaultUi: false,
      styles: _vm.styles
    }}},_vm._l((_vm.filteredMapData),function(group,index){return _c('GmapMarker',{key:index,attrs:{"position":_vm.createPosition(group.address),"clickable":true,"draggable":false}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }